// ** Navbar Components
import IntlDropdown from "./IntlDropdown"
import NotificationsBell from "./NotificationsBell"

// ** Lado derecho del header: solo idioma y avisos.
//
// La identidad (nombre, avatar, perfil, cerrar sesión) vive entera en la card del pie
// del sidebar. Tenerla también aquí repetía la misma información en la misma pantalla y
// obligaba a un header más alto para acomodarla.
//
// Lo que queda son ajustes de sesión que no pertenecen a ninguna pantalla concreta y no
// tienen sitio natural en el menú lateral.
//
// El toggle claro/oscuro se retiró antes: el rediseño no contempla modo oscuro y sus
// tokens solo están definidos en claro, así que dejarlo accesible permitía entrar a un
// tema a medio pintar. El skin queda fijo en "light" desde src/redux/layout.js.
const NavbarUser = () => {
  return (
    <div className="bp-header-actions ms-auto">
      <IntlDropdown />
      <NotificationsBell />
    </div>
  )
}

export default NavbarUser
